<template>
    <div class="row mt-4">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <h5 class="mb-0">Notes</h5>

                    <div v-if="notes.length">
                        <div class="note mt-4" :class="{'border border-danger' : note.type != TestNoteType.PRACTITIONER}" v-for="(note, index) in notes" :key="index">
                            <div class="note-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                <div><p class="mb-0 creator">{{ note.practitionerName ? note.practitionerName : 'Digostics Administrator' }}</p></div>
                                <div><p class="mb-0 text-sm"><span class="font-weight-bold font-italic mr-4">{{ note.type != TestNoteType.PRACTITIONER ? 'Reported' : 'Test' }} note</span> {{ note.dateCreated | moment("DD/MM/YYYY HH:mm")}}</p></div>
                            </div>

                            <div class="note-body text-sm">
                                {{ note.text }}
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <textarea class="form-control note" :class="{'border border-danger' : errors.length}" rows="4" placeholder="Add a note to the test" v-model="newNote"></textarea>
                        <small class="d-block text-danger">{{ errors[0] }}</small>

                        <div class="text-right">
                            <button :disabled="loading" @click="addNote()" class="btn btn-secondary sm-shadow mt-3 px-45" :class="{disabled : loading}">Save <span v-if="loading" class="btn-loading"></span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import axios from 'axios'
import TestNoteType from '../../../Common/enums/TestNoteType'
export default {
    name: 'TestNotesComponent',

    props: {
        notes: Array,
        testId: String
    },

    data() {
        return {
            loading: false,
            newNote: '',
            errors: [],
            TestNoteType
        }
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            practitionerId: 'UserStore/GetUserPractitionerId',
            userFullName: 'UserStore/GetUserFullName'
        })
    },

    methods: {
        ...mapActions({
            setNotification: 'NotificationStore/SetNotification'
        }),

        async addNote() {
            this.checkForm()

            if(!this.errors.length) {
                this.loading = true

                try {
                    await axios.post(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/testnotes/${this.organisationId}/${this.testId}`, {
                        text: this.newNote
                    })

                    this.newNote = ''

                    this.setNotification({
                        type: 'success',
                        title: 'Success',
                        message: 'The note was added successfully!'
                    })

                    this.$emit('reload')
                }
                catch(err) {
                    this.setNotification({
                        type: 'error',
                        title: 'Error',
                        message: 'Something went wrong. The note was not added. Please try again.'
                    })
                }
                finally {
                    this.loading = false
                }
            }            
        },

        checkForm() {
            this.errors = []

            if(!this.newNote) {
                this.errors.push("The note field is required")
            }
        }
    }
}
</script>